import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap";

/**
 * PaymentLinkRotateTokenModal – Sabit linkin adresini yenileme onayı.
 *
 * Yenileme sonrası eski adres anında geçersiz olduğu için işlem onay ister.
 */
const PaymentLinkRotateTokenModal = ({ isOpen, toggle, link, onConfirm, loading = false }) => (
    <Modal isOpen={isOpen} toggle={toggle} centered>
        <ModalHeader toggle={toggle} className="text-danger">
            <i className="bx bx-revision me-2" /> Link Adresini Yenile
        </ModalHeader>

        <ModalBody>
            <div className="text-center mb-3">
                <i className="bx bx-error-circle display-4 text-danger d-block mb-2" />
                <h5 className="mb-1">Emin misiniz?</h5>
                <p className="text-muted mb-0">
                    Link adresi yenilenecek ve <strong>eski adres anında geçersiz</strong> olacak.
                    Yeni adresi paylaşmayı unutmayın.
                </p>
            </div>

            {link && (
                <div className="bg-light rounded-4 p-3">
                    <div className="d-flex justify-content-between gap-3 mb-2">
                        <span className="text-muted small">Şirket</span>
                        <span className="fw-semibold text-end">{link.companyName || "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between gap-3 mb-2">
                        <span className="text-muted small">Cari / Bayi</span>
                        <span className="fw-semibold text-end">{link.accountName || "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between gap-3">
                        <span className="text-muted small">Mevcut Adres</span>
                        <span className="text-truncate text-end font-monospace small" style={{ maxWidth: 240 }} title={link.paymentLinkUrl}>
                            {link.paymentLinkUrl || "-"}
                        </span>
                    </div>
                </div>
            )}
        </ModalBody>

        <ModalFooter>
            <Button color="secondary" onClick={toggle} disabled={loading}>İptal</Button>
            <Button color="danger" onClick={onConfirm} disabled={loading}>
                {loading ? <Spinner size="sm" className="me-1" /> : <i className="bx bx-revision me-1" />}
                Evet, Yenile
            </Button>
        </ModalFooter>
    </Modal>
);

export default PaymentLinkRotateTokenModal;
